import { apiService } from "@base/configs";
import httpService from "@base/services/httpService";
import { IDeliveryAddress } from "./customerDeliveryAddress.interface";

class CustomerDeliveryAddressService {
  getMyAddresses() {
    return httpService.get<IDeliveryAddress[]>(apiService.patient.customerDeliveryAddress.myAddresses);
  }

  /** Creates when `id` is absent, updates otherwise - the same endpoint serves both. */
  save(payload: IDeliveryAddress) {
    return httpService.post<IDeliveryAddress>(apiService.patient.customerDeliveryAddress.save, payload);
  }

  delete(id: string | number) {
    return httpService.delete(`${apiService.patient.customerDeliveryAddress.delete}/${id}`);
  }
}

export default new CustomerDeliveryAddressService();
